module.exports = __webpack_public_path__ + "img/photo-0103.15f78b22.jpg";